import type React from 'react';

import { tabsPanel } from '@mage-ui/styled-system/recipes';
import { Tabs as MantineTab } from '@mantine/core';

export type TabsPanelProps = {
  classNames?: {
    panel?: string;
  };
  children?: React.ReactNode;
  value: string;
};

export const TabsPanel = ({
  classNames,
  children,
  ...props
}: TabsPanelProps) => {
  return (
    <MantineTab.Panel
      classNames={{
        panel: classNames?.panel ?? tabsPanel(),
      }}
      {...props}
    >
      {children}
    </MantineTab.Panel>
  );
};

TabsPanel.displayName = 'Tabs.Panel';
